<template>
  <div>
    <div v-if="isMobileNav && isMobileSidebarOpen" class="mobile-sidebar-backdrop" @click="closeMobileSidebar"></div>
    <div class="sidebar-container" :class="{ 'mobile-open': isMobileNav && isMobileSidebarOpen }">
    <div class="showBox" :class="{ hideBox: !isMobileNav && !isShowSider }">
      <div class="sidebarHeaderRow">
        <BrandBox v-show="isBrandMode" :isShow="effectiveShowSider" />
        <RestaurantBox v-show="!isBrandMode && isRestaurantRoute" :isShow="effectiveShowSider" />
        <HotelBox v-show="!isBrandMode && !isRestaurantRoute" :isShow="effectiveShowSider" />
        <img v-if="!isMobileNav" class="showHideBtn showImg" :src="isShowSider ? hideImg : showImg" @click="showHideSider" alt=""/>
      </div>
      <RouterMenu />
      <div class="BotBox BotBox1" v-if="effectiveShowSider">
<!--        <div class="textBox">-->
<!--          <p>{{ $t(`message.gmb`) }}</p>-->
<!--          <p class="p2">info@wheretoknow.com</p>-->
<!--        </div>-->
        <div class="logoutBox">
          <img class="logo" src="@/assets/img/logo.png" alt="Logo" />
          <img class="text" src="@/assets/img/whereToKnow_black.png" alt="" />
          <!-- 「重新查看引导」在 Help Center 标题行（FAQ/index.vue，按导览逐个重看）；
               语言切换在每页标题行最右端（components/common/LanguageSwitch.vue） -->
          <div class="footerActions">
            <Icon name="logout" class="logout" @click="dialogVisible=true" />
          </div>
        </div>
      </div>
      <div class="logoutBox" v-else>
        <img class="logo" src="@/assets/img/logo.png" alt="Logo" />
        <div class="hideDivider"></div>
        <Icon name="logout" class="logout" @click="dialogVisible=true" />
      </div>
      <el-dialog append-to-body :lock-scroll="false" custom-class="logoutDialogBox"
          :title="$t('login.Confir_Logout')"
          :visible.sync="dialogVisible"
          :before-close="handleClose">
        <div>{{$t('login.Are_you_sure_you_want_to_logout')}}</div>
        <div class="btnBox">
          <ModalButton type="secondary" @click="handleClose">{{$t('login.Cancel')}}</ModalButton>
          <ModalButton type="primary" @click="handleLogout">{{$t('login.Confirm')}}</ModalButton>
        </div>
      </el-dialog>
    </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { Icon } from "tdesign-icons-vue";
import HotelBox from "@/layout/components/Sidebar/hotelBox";
import RestaurantBox from "@/layout/components/Sidebar/restaurantBox.vue";
import BrandBox from "@/layout/components/Sidebar/brandBox.vue";
import RouterMenu from "@/layout/components/Sidebar/RouterMenu.vue";
import hideImg from "@/assets/img/hide.png";
import showImg from "@/assets/img/show.png";
import ModalButton from "@/components/common/ModalButton.vue";

export default {
  name: "Layout",
  data() {
    return {
      dialogVisible:false,
      hideImg,
      showImg,
    };
  },
  components: {
    Icon,
    HotelBox,
    RestaurantBox,
    BrandBox,
    RouterMenu,
    ModalButton,
  },
  mounted() {
    this.SET_MOBILE_NAV(window.innerWidth < 1024);
    window.addEventListener("resize", this.resizeHandler);
    // this.createRobot();
  },
  computed: {
    ...mapState({
      isShowSider: (state) => state.hotel.isShowSider,
      isMobileSidebarOpen: (state) => state.hotel.isMobileSidebarOpen,
      // <1024px：手机顶栏（见 Navbar.vue 的 isXs）接管导航，侧边栏默认完全隐藏，只能靠
      // 点汉堡菜单以浮层抽屉形式弹出——和桌面端"收起成图标条"是两个不同的概念，不能共用
      // isShowSider 一个字段表达。放 Vuex 里是因为 RouterMenu.vue 也要读它。
      isMobileNav: (state) => state.hotel.isMobileNav,
      IsItAutomaticallyFolded: (state) => state.hotel.IsItAutomaticallyFolded,
      isHotel: (state) => state.hotel.isHotel,
      isBrandMode: (state) => !!state.auth.selectedBrandName,
    }),
    isRestaurantRoute() {
      return !this.isHotel;
    },
    // 移动端抽屉打开时，内容一律按"展开"渲染（带文字的完整菜单），不受桌面端收起状态影响。
    effectiveShowSider() {
      return this.isMobileNav ? true : this.isShowSider;
    },
  },
  watch: {
    $route() {
      if (this.isMobileNav) this.SET_MOBILE_SIDEBAR_OPEN(false);
    },
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapMutations("hotel", ["SET_SHOW_SIDE", "SET_IsItAutomaticallyFolded", "SET_MOBILE_SIDEBAR_OPEN", "SET_MOBILE_NAV"]),
    closeMobileSidebar() {
      this.SET_MOBILE_SIDEBAR_OPEN(false);
    },
    // createRobot(){
    //   this.s1=document.createElement("script")
    //   this.s0=document.getElementsByTagName("script")[0];
    //   this.s1.async=true;
    //   this.s1.src='https://embed.tawk.to/6909ff1523927319492bdbd2/1j97gor4s';
    //   this.s1.charset='UTF-8';
    //   this.s1.setAttribute('crossorigin','*');
    //   this.s0.parentNode.insertBefore(this.s1,this.s0);
    // },
    // desRobot(){
    //   const tawkContainer = document.querySelector('#tawkchat-container');
    //   const tawkScript = document.querySelector('script[src*="tawk.to"]');
    //   if (tawkContainer) tawkContainer.remove();
    //   if (tawkScript) tawkScript.remove();
    // },
    resizeHandler() {
      const nowMobileNav = window.innerWidth < 1024;
      this.SET_MOBILE_NAV(nowMobileNav);
      if (!nowMobileNav) {
        // 抽屉只在手机模式下有意义；resize 回桌面宽度后强制关掉，避免下次缩回手机宽度时
        // 残留一个"打开"的状态、没有对应的手势触发就直接展示浮层。
        this.SET_MOBILE_SIDEBAR_OPEN(false);
      }
      if (document.body.clientWidth < 991) {
        this.SET_IsItAutomaticallyFolded(false);
        this.SET_SHOW_SIDE(false);
      } else {
        if (!this.IsItAutomaticallyFolded) {
          this.SET_SHOW_SIDE(true);
        }
      }
    },
    showHideSider() {
      this.SET_SHOW_SIDE(!this.isShowSider);
      this.SET_IsItAutomaticallyFolded(true);
    },
    handleClose(){
      this.dialogVisible = false;
    },
    handleLogout() {
      try {
        this.logout();
        // 跳转到登录页
        this.$router.push("/login");
        this.$toast.clear();
        this.$toast.success(this.$t("message.sidebar"), {
          toastClassName: "custom-success-toast",
          duration: 3000
        });
      } catch (error) {
        if (error !== "cancel") {
          console.error("Logout failed:", error);
        }
      }
    },
  },
  beforeDestroy() {
    // this.desRobot();
    window.removeEventListener("resize", this.scrollHandler);
  },
};
</script>

<style lang="scss" scoped>
.mobile-sidebar-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  // 必须低于 Element UI 弹层的起始 z-index(2000，见 hotelBox.vue 等 el-popover)，
  // 否则移动端抽屉打开后，酒店/门店切换下拉会被本遮罩盖住，点选项其实点到了遮罩上
  // （之前误从 1040 调到 2040 修另一个问题，反而引入了这个）。
  z-index: 1040; // 和 Navbar.vue 注释里"backdrop(1040)"的既有约定保持一致
}

.sidebar-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  margin-top: 10px;
  margin-left: 12px;
  //min-height: 600px !important;
  height: calc(100vh - 24px) !important;
  box-sizing: border-box;
  background: var(--sidebar-bg);
  // border-right: 1px solid var(--sidebar-border);
  border-radius: 16px;
  font-family: Inter, sans-serif !important;
  /* Sits beside the brand/hotel selector in a normal flex row instead of an
     absolutely-positioned fixed offset — the selector's height varies (a
     long hotel name wraps to 2 lines), so a fixed top: value drifted out of
     alignment with it. Row for expanded, stacked column for collapsed (see
     .hideBox override below). */
  .sidebarHeaderRow {
    display: flex;
    align-items: center;
    gap: 4px;

    .brandBoxWrap, .hotelBoxWrap, .restaurantBoxWrap {
      flex: 1;
      min-width: 0;
    }
  }
  .showHideBtn {
    display: block;
    width: 41px;
    height: 41px;
    flex-shrink: 0;
    cursor: pointer;
  }
  .BotBox {
    border-top: 1px solid var(--sidebar-border);
    padding-top: 16px;
    padding-bottom: 8px;
    .textBox {
      padding-bottom: 16px;
      border-bottom: 1px solid #D9D9D9;
      margin-bottom: 16px;
      p {
        margin: 0;
        color: #99b1c0;
        font-weight: 600;
        font-size: 12px;
        line-height: 1.5;
      }
      .p2 {
        font-weight: 400;
        font-size: 12px;
        line-height: 100%;
        color: #9fb8cc;
        margin-top: 4px;
      }
    }
    .logoutBox {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      // Logo + wordmark are one lockup — keep them together; the remaining
      // footer action (logout) is pushed to the far right by margin-left: auto.
      gap: 8px;
      padding: 0 4px;
      .footerActions {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 2px;
      }
      img {
        display: inline-block;
      }
      .logo {
        width: 36px;
        height: 24px;
      }
      .text {
        // Shrunk from 104x12 to leave the footer row room for the language
        // button (globe + current language) and logout without wrapping.
        width: 88px;
        height: 10px;
      }
      .logout {
        display: inline-block;
        color: var(--sidebar-text-muted);
        width: 14px;
        height: 14px;
        cursor: pointer;
        transition: color 0.2s;
        &:hover {
          color: var(--sidebar-accent);
        }
      }
    }
  }
  .showBox {
    width: 240px;
    padding: 24px 12px 20px;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: width 0.22s ease;
    ::v-deep .RouterMenuBox {
      flex: 1;
      min-height: 0;
      height: auto !important;
    }
  }
  .hideBox {
    width: 72px;
    padding: 24px 8px 20px;
    box-sizing: border-box;
    height: 100%;
    // Collapsed sidebar is too narrow for the selector and toggle button
    // side by side — stack them instead.
    .sidebarHeaderRow {
      flex-direction: column;
      gap: 8px;

      .brandBoxWrap, .hotelBoxWrap, .restaurantBoxWrap {
        flex: none;
        width: 100%;
      }
    }
    .logoutBox {
      //position: absolute;
      //padding: 24px 18px;
      //bottom: 0;
      //left: 0;
      display: block;
      text-align: center;
      .logo {
        margin: 0 auto;
        display: block;
        width: 36px;
        height: 24px;
      }
      .hideDivider {
        height: 1px;
        width: 100%;
        background: var(--sidebar-border);
        margin: 16px 0;
      }
      .logout {
        display: inline-block;
        color: var(--sidebar-text-muted);
        width: 16px;
        height: 16px;
        cursor: pointer;
        &:hover {
          color: var(--sidebar-accent);
        }
      }
    }
  }
}

// <1024px：和 Navbar.vue 的手机顶栏用同一个阈值。默认整块移出视口（而不是收起成图标条——
// 那是桌面端才有的中间态），点汉堡菜单才作为浮层滑入；.mobile-open 由 isMobileSidebarOpen 控制。
// 必须放在这个文件最后：和上面 .sidebar-container{z-index:1001} 是同一选择器、同等特异度，
// 写在前面会被后面那条无条件规则盖掉（就是这样才踩过一次坑——z-index 实测一直是 1001，
// backdrop(1040) 反而盖在了侧边栏上面，点菜单项点到了 backdrop 头上）。
@media (max-width: 1023px) {
  .sidebar-container {
    transform: translateX(calc(-100% - 12px)); // -12px 是自己的 margin-left，一起移出去
    transition: transform 0.22s ease;
    z-index: 1045; // 高于 Navbar 手机顶栏(1011)，同样要低于 Element UI 弹层起始值(2000)
    &.mobile-open {
      transform: translateX(0);
    }
  }
}
</style>


<style>
.el-dialog__wrapper:has(.logoutDialogBox) {
  display: flex;
  align-items: center;
  justify-content: center;
}
.logoutDialogBox{
  width: 400px !important;
  margin: 0 !important;
  border-radius: 16px !important;
  .el-dialog__header{
    padding: 24px;
    padding-bottom: 16px;
    .el-dialog__title{
      display: block;
      font-family: Inter,sans-serif;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #232323;
    }
  }
  .el-dialog__body{
    padding:0 24px 24px;
    font-family: Inter,sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #000000;
    .btnBox{
      margin-top: 16px;
      display: flex;
      justify-content: right;
      gap: 12px;
    }
  }
}
</style>
